// utils/getPrixMoyenProduitParprovince.ts - NOUVEAU FICHIER
import { PrixMarcheParProvince } from "../types";

export default (res: any[]): PrixMarcheParProvince[] => {  // any[] car nouvelle structure
  try {
    // Étape 1: Dernier prix par marché (basé sur dateAjout)
    const marcheMap = new Map<string, any>();
    res.forEach((p) => {
       if (!p.marche || !p.marche.nomMarche) {
        return ;
      }
      const exist = marcheMap.get(p.marche.nomMarche);
      if (!exist || new Date(p.dateAjout) > new Date(exist.dateAjout)) {
        marcheMap.set(p.marche.nomMarche, p);
      }
    });

    const dernierPrixParMarche = Array.from(marcheMap.values());

    // Étape 2: Grouper PAR province (marche.province.nom)
    const provinceMap = new Map<string, { prix: number[]; marche: string[] }>();
    dernierPrixParMarche.forEach((p) => {
      const prix = p.prixUnite1;  // ← CHANGÉ : prix → prixUnite1
      const province =p.marche.commune.departement.province.nom ;  // ← CHANGÉ : p.region → p.marche.departement.province.nom
       const nomMarche = p.marche?.nomMarche || "Marché inconnu";  // ← CHANGÉ : p.marche → p.marche.nomMarche

if (!prix || !province || !nomMarche) {
        return;
      }
    
        if (!provinceMap.has(province)) provinceMap.set(province, { prix: [], marche: [] });
        provinceMap.get(province)!.prix.push(prix);
        provinceMap.get(province)!.marche.push(nomMarche);
      
    });

    // Étape 3: Résultat
    return Array.from(provinceMap.entries()).map(([province, { prix, marche }]) => ({
      province,  
     marche: marche.length ? marche.join(", ") : "N/A",
      min: Math.min(...prix),
      max: Math.max(...prix),
      moyenne: prix.reduce((a, b) => a + b, 0) / prix.length,
      nbMarches: prix.length,
    }));
  } catch (error) {
    console.error("Erreur calcul prix par province:", error);
    return [];
  }
};